// extracted by mini-css-extract-plugin
module.exports = {"af78vbn":"af78vbn","h9chdl6":"h9chdl6"};